import { render, staticRenderFns } from "./FixingArea.vue?vue&type=template&id=aa1fc6a4&"
import script from "./FixingArea.vue?vue&type=script&lang=js&"
export * from "./FixingArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports